<div class="h-full flex flex-col">
  <div class="flex grow min-h-0 gap-2 mt-3">
    <!-- COLLAPSIBLE SIDEBAR WRAPPER -->
    <div *ngIf="items.length" class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
      <!-- TOGGLE BUTTON WITH ARROW ICON -->
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <!-- SIDEBAR CONTAINER WITH MENU -->
      <div class="sidebar-container">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>
      </div>
    </div>
    <!-- MAIN CONTENT AREA -->
    <div class="grow flex flex-col min-h-0 ml-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
